var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebHook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1 -1 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M10.977083333333333 7.05837c0.7594583333333333 0 1.375 -0.6156149999999999 1.375 -1.375 0 -0.7593941666666666 -0.6155416666666667 -1.375 -1.375 -1.375 -0.7593666666666666 0 -1.375 0.6156058333333333 -1.375 1.375 0 0.759385 0.6156333333333333 1.375 1.375 1.375Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M4.743740833333334 17.599999999999998c0.759385 0 1.375 -0.6155416666666667 1.375 -1.375 0 -0.7593666666666666 -0.6156149999999999 -1.375 -1.375 -1.375 -0.7593941666666666 0 -1.375 0.6156333333333333 -1.375 1.375 0 0.7594583333333333 0.6156058333333333 1.375 1.375 1.375Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M17.11875 17.599999999999998c0.7593666666666666 0 1.375 -0.6155416666666667 1.375 -1.375 0 -0.7593666666666666 -0.6156333333333333 -1.375 -1.375 -1.375s-1.375 0.6156333333333333 -1.375 1.375c0 0.7594583333333333 0.6156333333333333 1.375 1.375 1.375Z",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M14.208333333333332 19.25c1.65 1.65 4.216666666666666 1.65 5.866666666666667 0 1.65 -1.65 1.65 -4.216666666666666 0 -5.866666666666667 -1.375 -1.375 -3.483333333333333 -1.5583333333333331 -5.041666666666666 -0.6416666666666666l-3.4587666666666665 -5.825361666666667",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M3.6208333333333336 12.283333333333333c-1.65 0.4583333333333333 -2.9333333333333336 2.108333333333333 -2.9333333333333336 3.9416666666666664 0 2.2916666666666665 1.8333333333333333 4.125 4.125 4.125s4.125 -1.8333333333333333 4.125 -4.125h6.811566666666666",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.010416666666666 6.783315c0.27499999999999997 -1.375 -0.09166666666666667 -2.841666666666667 -1.0999999999999999 -3.85 -1.65 -1.65 -4.216666666666666 -1.65 -5.866648333333333 0 -1.8333333333333333 1.925 -1.5583333333333331 5.041675833333333 0.825 6.508351666666666l-3.286745 5.6851666666666665",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebHook);
export default __webpack_public_path__ + "static/media/web-hook.a378b8e2.svg";
export { ForwardRef as ReactComponent };